import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-featured',
  templateUrl: './featured.component.html',
  styleUrls: ['./featured.component.scss']
})
export class FeaturedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  featuredItem = {
    title: 'YoGamez Pro, the home of champions.',
    subtitle: 'Play. Compete. Win. Repeat.',
    bgImage: '/assets/featured/featured-bg.jpg',   // big background artwork
    characterImage: '/assets/featured/character.png' // right side character
  };

  current = 0;

  // Carousel controls (future use)
  next() { /* logic for multiple featured slides */ }
  prev() { /* logic for multiple featured slides */ }

  onExploreClick(): void {
    // Add your explore functionality here
    console.log('Explore clicked');
  }
}
